// extracted by mini-css-extract-plugin
export var borderRadius = "_gx-4";
export var large = "_gx-3";
export var logoContainer = "_gx-0";
export var nameLogo = "_gx-2";
export var small = "_gx-1";